export enum EDeleteMode {
    DIRECT = 'DIRECT',
    CONFIRM = 'CONFIRM',
    CONFIRM_REENFORCED = 'CONFIRM_REENFORCED'
}
